/*
 *
 * CostsDebitDetailsDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 20-Aug-2025
*/

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import './CostsDebitDetailsDownloadModal.scss'
import { DocumentXLS, DocumentCVS } from '@nexidigital/iconlibrary'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'

const CostsDebitDetailsDownloadModal = (props) => {
  const [downloadingFormat, setDownloadingFormat] = useState(null)

  const handleDownloadCSV = () => {
    setDownloadingFormat('CSV')

    const payload = {
      request: {
        ...props.filters
      },
      paymentsDownloadData: {
        downloadType: props.typeTabDownload,
        format: 'CSV'
      }
    }

    props.asyncDownload(payload)
  }
  const handleDownloadExcel = () => {
    setDownloadingFormat('EXCEL')

    const payload = {
      request: {
        ...props.filters
      },
      paymentsDownloadData: {
        downloadType: props.typeTabDownload,
        format: 'EXCEL'
      }
    }

    props.asyncDownload(payload)
  }

  useEffect(() => {
    if (!props.isDownloadLoading && downloadingFormat) {
      setDownloadingFormat(null)
    }
  }, [props.isDownloadLoading, downloadingFormat])
  return (
    <Toggle>
      <MerchantModal
        onClose={props.onClose}
        title={props.title}
        description={props.subtitle}
        primaryAction={() => handleDownloadExcel()}
        primaryButtonLoading={props.isDownloadLoading && downloadingFormat === 'EXCEL'}
        primaryButtonLabel={props.primaryButtonLabel}
        primaryIcon={<DocumentXLS size='24' type='line' />}
        primaryButtonTertiary
        secondaryAction={() => handleDownloadCSV()}
        secondaryButtonLoading={props.isDownloadLoading && downloadingFormat === 'CSV'}
        secondaryButtonLabel={props.secondaryButtonLabel}
        secondaryIcon={<DocumentCVS size='24' type='line' />}
        secondaryButtonTertiary
        customAnalyticsDescription={formattedMessage.description}
      >
        {props.formatInfoMessage && <div>{props.formatInfoMessage}</div>}
        <MerchantToastMessage
          severity='info'
          showOnPage
          hideClose
          label={props.description}
        />
      </MerchantModal>
    </Toggle>
  )
}

CostsDebitDetailsDownloadModal.propTypes = {
  actions: PropTypes.object,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  isDownloadLoading: PropTypes.bool,
  filters: PropTypes.object,
  typeTabDownload: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  asyncDownload: PropTypes.func,
  formatInfoMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

CostsDebitDetailsDownloadModal.defaultProps = {
  actions: {},
  onClose: () => { },
  title: '',
  subtitle: '',
  description: '',
  primaryButtonLabel: '',
  isDownloadLoading: false,
  filters: {},
  typeTabDownload: '',
  secondaryButtonLabel: '',
  asyncDownload: () => { },
  formatInfoMessage: ''
}

export default CostsDebitDetailsDownloadModal
